/** @format */
import { _$ } from '@king-design/react'
import { keepDecimal } from 'src/utils/common'
// 告警规则
export interface TriggerRulesProps extends TriggerRulesItemProps {
  compare?: string
  effectBT?: string
  effectET?: string
  interval?: string
  maxCount?: number
  method?: string
  period?: string
  points?: string
  triggerValue?: string
  levelValue?: LevelValueProps
  ruleId?: number
  displayUnits?: string
}

// 告警分级
export interface LevelValueProps {
  Critical?: LevelValueItemProps
  Error: LevelValueItemProps
  Warning?: LevelValueItemProps
}
export type LevelValueItemProps = {
  Value: string
  Units?: string
  DisplayUnits?: string
}
export const initLevelValue: LevelValueProps = {
  Critical: {
    Value: '',
    Units: '',
    DisplayUnits: ''
  },
  Error: {
    Value: '0',
    Units: '',
    DisplayUnits: ''
  },
  Warning: {
    Value: '',
    Units: '',
    DisplayUnits: ''
  }
}
// 告警规则监控项
export interface TriggerRulesItemProps {
  itemName?: string
  itemKey?: string
  units?: string
  tags?: string
}

// 统计周期
export const periodOption = [
  { value: '1m', title: _$('1分钟'), key: 1 },
  { value: '3m', title: _$('3分钟'), key: 3 },
  { value: '5m', title: _$('5分钟'), key: 5 },
  { value: '10m', title: _$('10分钟'), key: 10 },
  { value: '15m', title: _$('15分钟'), key: 15 },
  { value: '30m', title: _$('30分钟'), key: 30 },
  { value: '60m', title: _$('1小时'), key: 60 }
]
// 告警间隔
export const intervalOption = [
  { value: 5, title: _$('5分钟') },
  { value: 10, title: _$('10分钟') },
  { value: 15, title: _$('15分钟') },
  { value: 30, title: _$('30分钟') },
  { value: 60, title: _$('1小时') },
  { value: 120, title: _$('2小时') },
  { value: 180, title: _$('3小时') },
  { value: 360, title: _$('6小时') },
  { value: 720, title: _$('12小时') },
  { value: 1440, title: _$('24小时') }
]
// 统计方法option
export const methodOption = [
  { value: 'avg', title: _$('平均值') },
  { value: 'max', title: _$('最大值') },
  { value: 'min', title: _$('最小值') },
  { value: 'sum', title: _$('求和值') }
]

// 周期环比
export const thanLastPeriod = ['GreaterThanLastPeriod', 'LessThanLastPeriod']

// 大小选择option
export const unitOption = [
  { value: '>', title: '>' },
  { value: '<', title: '<' },
  { value: '=', title: '=' },
  { value: 'GreaterThanLastPeriod', title: '周期环比上涨' },
  { value: 'LessThanLastPeriod', title: '周期环比下降' }
]
// 持续周期option
export const pointsOption = [
  { value: 1, title: 1 },
  { value: 2, title: 2 },
  { value: 3, title: 3 },
  { value: 4, title: 4 },
  { value: 5, title: 5 },
  { value: 6, title: 6 },
  { value: 7, title: 7 },
  { value: 8, title: 8 },
  { value: 9, title: 9 },
  { value: 10, title: 10 },
  { value: 11, title: 11 },
  { value: 12, title: 12 }
]

export const countOption = [
  { value: 1, title: '1' },
  { value: 2, title: '2' },
  { value: 3, title: '3' },
  { value: 4, title: '4' },
  { value: 5, title: '5' }
]

export const initRuleItem: TriggerRulesProps = {
  interval: '', // 统计粒度
  method: '', // 统计方法
  compare: '', // 大小
  triggerValue: '', // yuzhi
  points: '',
  maxCount: null,
  effectBT: '00:00',
  effectET: '23:59',
  period: '',
  ruleId: 0,
  itemName: '',
  itemKey: '',
  units: '',
  displayUnits: '',
  levelValue: initLevelValue
}

// 不需要配置阈值等规则的特殊监控项[宕机，,mongodb实例存活监控]
export const withCustomRule = ['agent.ping', 'kdc.alive', 'mongo.mongo_alive']

/**
 * 处理不可选规则特殊监控项
 * @param itemKey 监控项key
 * @returns 默认规则值
 */
export const setItemSpacial = itemKey => {
  switch (itemKey) {
    case 'agent.ping':
      return {
        Compare: '=',
        TriggerValue: '0',
        Points: 3,
        Period: '20s'
      }
    case 'kdc.alive':
      return {
        Compare: '=',
        TriggerValue: '0',
        Points: 1,
        Period: '1m'
      }
    case 'mongo.mongo_alive':
      return {
        Compare: '=',
        TriggerValue: '0',
        Points: 3,
        Period: '1m'
      }
    default:
      if (itemKey?.includes('.nodata')) {
        return {
          Compare: '=',
          TriggerValue: '0'
        }
      }
      return {}
  }
}
export const handleDataUnitsValue = (value, units) => {
  // 换算图标value
  if (units === 'bps') {
    return {
      units: 'Mbps',
      triggerValue: value ? parseFloat(value) / 1024 / 1024 : 0
    }
  } else if (units === 'Kbps') {
    return {
      units: 'Mbps',
      triggerValue: value ? parseFloat(value) / 1024 : 0
    }
  } else {
    return {
      units,
      triggerValue: value
    }
  }
}
// 单位转换
export const handleUnitsValue = (
  value: number | string,
  unit: string,
  targetUnit: string,
  unitOpts: string[]
): any => {
  let value_numer: number = typeof value === 'string' ? parseFloat(value as string) : value
  const curIndex = unitOpts.indexOf(unit)
  const targetIndex = unitOpts.indexOf(targetUnit)
  const base = unit.includes('B') || unit.includes('bps') ? 1024 : 1000
  let index = curIndex
  if (curIndex > -1 && targetIndex > -1) {
    if (curIndex > targetIndex) {
      // 向下进制
      while (index > targetIndex) {
        value_numer = value_numer * base
        index -= 1
      }
    } else if (curIndex < targetIndex) {
      //向上进制
      while (index < targetIndex) {
        value_numer = value_numer / base
        index += 1
      }
    }
    return keepDecimal(value_numer)
  } else {
    return value
  }
}
// 阈值告警策略支持单位转换的监控项
export const UnittransformMetrics = {
  0: [
    'vm.memory.size',
    'disk.write.Bps',
    'disk.read.Bps',
    'net.if.out',
    'net.if.in',
    'vm.memory.free'
  ],
  15: [
    'vm.memory.free',
    'vm.memory.size',
    'disk.write.Bps',
    'disk.read.Bps',
    'net.if.in_bps',
    'net.if.out_bps'
  ],
  20: ['disk.write.Bps', 'disk.read.Bps', 'net.if.out', 'net.if.in'],
  21: [
    'gpu.memory.free',
    'vm.memory.size',
    'disk.write.Bps',
    'disk.read.Bps',
    'net.if.out',
    'net.if.in'
  ],
  43: [
    'vm.memory.size',
    'npu.chip.info.hbm.used.memory',
    'npu.chip.info.hbm.total.memory',
    'rx.prio5.bytes',
    'tx.prio5.bytes',
    'gpu.memory.reserved',
    'rx.bytes.phy',
    'npu.chip.info.used.memory',
    'npu.chip.info.total.memory',
    'tx.bytes.phy',
    'vm.memory.free',
    'disk.write.Bps',
    'disk.read.Bps',
    'net.if.in_bps',
    'net.if.out_bps'
  ],
  75: [
    'elasticsearch_jvm_memory_used_bytes',
    'elasticsearch_filesystem_data_available_bytes',
    'elasticsearch_filesystem_io_stats_device_write_size_kilobytes_sum',
    'elasticsearch_filesystem_io_stats_device_read_size_kilobytes_sum'
  ]
}
// 阈值告警单位转换

export const getMetricUnitOptions = (productType: number, metricKey: string, unit: string) => {
  const B_ops = ['B', 'KB', 'MB', 'GB']
  const b_ops = ['b', 'Kb', 'Mb', 'Gb']
  const Bps_ops = ['Bps', 'KBps', 'MBps', 'GBps']
  const bps_ops = ['bps', 'Kbps', 'Mbps', 'Gbps']
  if (UnittransformMetrics[productType]?.includes(metricKey)) {
    if (B_ops.includes(unit)) {
      const start = B_ops.indexOf(unit)
      return B_ops.splice(start)
    }
    if (b_ops.includes(unit)) {
      const start = b_ops.indexOf(unit)
      return b_ops.splice(start)
    }
    if (Bps_ops.includes(unit)) {
      const start = Bps_ops.indexOf(unit)
      return Bps_ops.splice(start)
    }
    if (bps_ops.includes(unit)) {
      const start = bps_ops.indexOf(unit)
      return bps_ops.splice(start)
    }
    return []
  }
  return []
}

// 处理单位
export const bps_ops = ['bps', 'Kbps', 'Mbps', 'Gbps']
export const handleMetricUnits = (productType, metricKey, triggerValue, units, displayUnits) => {
  const unitOpts = getMetricUnitOptions(productType, metricKey, units)
  let value = triggerValue
  if (unitOpts?.length) {
    value = handleUnitsValue(triggerValue, units, displayUnits, unitOpts)
  } else if (units === 'bps' && displayUnits === 'Mbps') {
    value = handleUnitsValue(triggerValue, units, displayUnits, bps_ops)
  }
  return value
}
